import {
  USER_ROLE_ADMIN,
  USER_ROLE_MAILING,
  USER_ROLE_STATS,
  USER_ROLE_STUD,
  USER_ROLE_WIKI
} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

export default [
  {
    name: messages.common.sidebar_links.newsletters.main,
    icon: 'static/img/icons/sidebarmenu/newsletters.svg',
    access: USER_ROLE_MAILING,
    path: '/newsletters/list',
    // isLink: true,
    children: [
      {
        name: messages.common.sidebar_links.newsletters.students,
        path: '/newsletters/'
      },
      {
        name: messages.common.sidebar_links.newsletters.staff,
        path: '/newsletters-stuff/'
      }
    ]
  },
  {
    name: messages.common.sidebar_links.polls.main,
    icon: 'static/img/icons/sidebarmenu/polls.svg',
    access: USER_ROLE_MAILING,
    isLink: true,
    path: '/polls/list'
  },
  {
    name: messages.common.sidebar_links.students.main,
    icon: 'static/img/icons/sidebarmenu/students.svg',
    access: USER_ROLE_STUD,
    isLink: true,
    path: '/students/list'
    // children: [
    //   {
    //     name: messages.students.list,
    //     path: '/students/list'
    //   }
    // ]
  },
  {
    name: messages.common.sidebar_links.staff.main,
    icon: 'static/img/icons/sidebarmenu/staff.svg',
    isLink: true,
    path: '/users/list'
    // children: [
    //   {
    //     name: messages.employees.create,
    //     path: '/users/create',
    //     access: USER_ROLE_ADMIN
    //   },
    //   {
    //     name: messages.employees.list,
    //     path: '/users/list'
    //   }
    // ]
  },
  {
    name: messages.common.sidebar_links.organizations.main,
    icon: 'static/img/icon_department.svg',
    isLink: true,
    path: '/orgs/list'
    // children: [
    //   {
    //     name: messages.orgs.add_subdivision,
    //     path: '/orgs/create',
    //     access: USER_ROLE_ADMIN
    //   },
    //   {
    //     name: messages.orgs.subdivisions_list,
    //     path: '/orgs/list'
    //   }
    // ]
  },
  {
    name: messages.common.sidebar_links.wiki.main,
    icon: 'static/img/icons/sidebarmenu/info.svg',
    isLink: true,
    path: '/wiki/list'
    // children: [
    //   {
    //     name: messages.wiki.list_page_name,
    //     path: '/wiki/list'
    //   },
    //   {
    //     name: messages.wiki.create_page_name,
    //     path: '/wiki/createPage',
    //     access: USER_ROLE_WIKI
    //   },
    //   {
    //     name: messages.wiki.create_node_name,
    //     path: '/wiki/createNode',
    //     access: USER_ROLE_WIKI
    //   }
    // ]
  },
  {
    name: messages.common.sidebar_links.settings.main,
    icon: 'static/img/icons/sidebarmenu/settings.svg',
    path: '/settings',
    children: [
      {
        name: messages.common.sidebar_links.settings.messengers,
        path: '/settings/messengers'
      },
      // {
      //   name: messages.common.sidebar_links.settings.news,
      //   path: '/settings/news'
      // }
    ]
  }
];